/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

export function AuthPage() {
  return (
    <>
    
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div className="login login-4 wizard d-flex flex-column flex-lg-row flex-column-fluid">
          {/* begin::Content */}
          <div className="login-container order-2 order-lg-1 d-flex flex-center flex-row-fluid px-7 pt-lg-0 pb-lg-0 pt-4 pb-6 bg-white" id="kt_login"
          style={{ backgroundImage: `url(${toAbsoluteUrl("/media/logos/banner1.jpg")})`, backgroundRepeat: 'no-repeat'  }}>
            {/* begin::Wrapper */}
            <div className="login-content d-flex flex-column pt-lg-0 pt-12">
              {/* begin::Logo */}
              <Link to="/" className="login-logo pb-10 text-center">
                <img src={toAbsoluteUrl("/media/logos/logo-v.png")} className="max-h-65px ta" alt="" />
              </Link>
              {/* end::Logo */}
              {/* begin::Signin */}
              
                {/* <div className="d-flex flex-column-fluid flex-left mt-30 mt-lg-0"> */}
                  
                  <Switch>
                    <ContentRoute path="/auth/login" component={Login} />
                    <ContentRoute
                      path="/auth/registration"
                      component={Registration}
                    />
                    <ContentRoute
                      path="/auth/forgot-password"
                      component={ForgotPassword}
                    />
                    <Redirect from="/auth" exact={true} to="/auth/login" />
                    <Redirect to="/auth/login" />
                  </Switch>
                {/* </div> */}
              {/* end::Signin */}
            </div>
            {/* end::Wrapper */}
          </div>
          {/* begin::Content */}
          {/* begin::Aside */}
          {/* <div className="login-aside order-1 order-lg-2 bgi-no-repeat bgi-position-x-right">
            <div className="login-conteiner bgi-no-repeat bgi-position-x-right bgi-position-y-bottom"
              style={{
                backgroundImage: `url(${toAbsoluteUrl("/media/svg/illustrations/login-visual-4.svg")})`,
              }}>
              <h3 className="pt-lg-40 pl-lg-20 pb-lg-0 pl-10 py-20 m-0 d-flex justify-content-lg-start font-weight-boldest display5 display1-lg text-white">
                We Got<br />A Surprise<br />For You
              </h3>
            </div>
          </div> */}
          {/* end::Aside */}
        </div>
        {/* end::login */}
      </div>
    </>
  );
}
